<template>
  <div>
    <a-layout-content :style="{ padding: '0 10px', marginTop: '86px' }">
      <div :style="{ background: '#fff', padding: '12px' }">
        <a-spin
          :spinning="spinning"
          :tip="this.$t('ujian.finish.end-off-time-message')"
          size="large"
          :wrapperClassName="spinstyle"
        >
          <div :style="{ minHeight: '300px' }">
            <a-row type="flex">
              <a-col
                class="gutter-row"
                :span="8"
                flex="1 1 200px"
                :style="{
                  background: '#transparent',
                  padding: '16px',
                }"
              >
                <kategori-ujian :itemKategori="itemKategoriSoal.list">
                </kategori-ujian>
              </a-col>
              <a-col
                class="gutter-row"
                :span="16"
                flex="1 1 700px"
                :style="{
                  background: '#transparent',
                  padding: '16px',
                  minHeight: '380px',
                }"
              >
                <div class="gutter-box-ujian">
                  <a-card size="small">
                    <div slot="title">
                      {{ $t("ujian.ujian-dashboard.question-number") }}
                      <a-tag color="#108ee9">{{ itemSoal.index + 1 }}</a-tag>
                    </div>

                    <div slot="extra">
                      {{ $t("ujian.ujian-dashboard.question-category") }}
                      <a-tag color="#108ee9">{{ itemSoal.list.name }}</a-tag>
                      <a-tag
                        color="#f50"
                        @click="showModal"
                        slot="extra"
                        style="cursor: pointer"
                      >
                        Ganti Kategori Soal
                      </a-tag>
                    </div>
                    <div class="example" v-if="isLoadSoal">
                      <a-spin />
                    </div>
                    <template v-else>
                    <soal
                      :itemsoal="itemDetailSoal"
                      :itemjawaban="itemjawaban"
                      @set-jawaban="setJawaban"
                    ></soal>                    
                      <template slot="actions" class="ant-card-actions">
                        <a-button type="warning" @click="prevSoal()">
                          <a-icon type="left" />{{ $t("general.button.before") }}
                        </a-button>

                        <div
                          class="mark-button"
                          @click="setFlag(itemSoal.index)"
                          :class="{
                            marker: this.itemDetailSoal.list_answer_participant.flag == 1,
                          }"
                        >
                          <span
                            style="padding-top: 5px; vertical-align: middle"
                            >  {{ $t("general.button.set-flag-question") }}</span
                          >
                        </div>
                        <a-button type="primary" @click="nextSoal()">
                          {{ $t("general.button.next")  }} <a-icon type="right" />
                        </a-button>
                        
                      </template>
                    </template>
                  </a-card>
                </div>
              </a-col>
              <a-col
                class="gutter-row"
                :span="8"
                flex="1 1 200px"
                :style="{
                  background: '#transparent',
                  padding: '16px',
                }"
              >
                <div class="gutter-box-ujian">
                  <a-card size="small">
                    <waktu-ujian
                      :tglStart="tglStart"
                      @finish-examp="finishExamp"
                      @in-finish-examp="inFinishExamp"
                    ></waktu-ujian>
                    <a-divider>Hasil Jawaban</a-divider>
                    <detail-option-answer
                      :itemDetailSoal="itemSoal.list"
                      :indexSoal="itemSoal.index"
                      style="text-align: center"
                      @set-soal="setSoal"
                    >
                    </detail-option-answer>
                  </a-card>
                  <br />
                </div>
              </a-col>
            </a-row>
          </div>
        </a-spin>
      </div>
    </a-layout-content>
    <a-modal
      v-model="visible"
      title="Ganti Kategori"
      :footer="null"
      :maskClosable="false"
      :closable="false"
    >
      <a-result
        :title="this.$t('ujian.start-examp.placeholder')"
        :sub-title="sub_title"
        :status="icontype"
      >
        <template #extra>
          <a-button
            style="text-align: center; margin-top: -40px"
            @click="changeGroupFalse"
          >
            {{ $t("general.button.not-change") }}
          </a-button>
          <a-button
            style="text-align: center; margin-top: -40px"
            type="primary"
            :loading="iconLoading"
            @click="changeGroup"
          >
            {{ $t("general.button.change-examp") }}
          </a-button>
        </template>
        <div style="text-align: center; margin-top: -40px">
          <a-select
            :placeholder="this.$t('ujian.start-examp.placeholder')"
            style="width: 100%"
            @change="handleChange"
          >
            <a-select-option
              v-for="item in itemKategoriSoal.list"
              :key="item.id_group"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </div>
      </a-result>
    </a-modal>
    <a-modal
      v-model="visibleFinish"
      title="Selesai Ujian"     
      :maskClosable="false"
      :footer="null"
      :closable="false"
    >
      <a-result
        :title="this.$t('ujian.ujian-dashboard.in-finish-exampt')"
        status="warning"
      >
         <template #extra>
          <a-button key="ya" type="primary" @click="inFinishOK">
            Yakin
          </a-button>
          <a-button key="cancel" @click="inFinishCancel">
            Tidak, Kembali ke Halaman Ujian
          </a-button>
        </template>
      </a-result>
    </a-modal>
  </div>
</template>

<script>
import Soal from "@/views/components/ujian/Soal.vue";
import WaktuUjian from "@/views/components/ujian/WaktuUjian.vue";
import DetailOptionAnswer from "@/views/components/ujian/DetailOptionAnswer.vue";
import KategoriUjian from "@/views/components/ujian/KategoriUjian.vue";
import { get, post } from "@/services/api";
// import moment from 'moment'

export default {
  components: {
    Soal,
    WaktuUjian,
    DetailOptionAnswer,
    KategoriUjian,
  },
  data() {
    return {
      sub_title: "",
      icontype: "",
      isChangeSoal: true,
      isLoadSoal: false,
      isTimeFinish: false,
      visible: false,
      visibleFinish:false,
      spinning: false,
      iconLoading: false,
      spinstyle: "",
      delayTime: 600,
      selectedGroupSoal: "",
      itemDetailSoal: {},
      itemjawaban: {},
      itemSoal: {
        index: 0,
        list: [],
      },
      selectedJawab: {},
      itemKategoriSoal: {
        selected: {},
        list: [],
      },
      //1800000 => 30 Menit -
      tglStart: 5400000,
    };
  },
  methods: {
    
    showModal() {
      // console.log(this.itemKategoriSoal.list);
      this.visible = true;
      this.selectedGroupSoal = this.$store.state.participant.ujian.selected_kategori;
      this.sub_title = this.$t(
        "ujian.ujian-dashboard.before-finish-one-group",
        { groupname: this.itemSoal.list.nama }
      );
      this.icontype = "warning";
      // if(this.itemKategoriSoal.list[this.itemKategoriSoal.list.findIndex(
      //   (item) =>
      //     item.id_group == this.$store.state.participant.ujian.selected_kategori
      // )].number_of_remain > 0)
      this.isChangeSoal = true;
      this.endSoal();
    },
    handleChange(value) {
      this.selectedGroupSoal = value;
      //this.$store.commit('setSelectedKategori', this.selectedGroupSoal);
    },
    changeGroup() {
      if (this.selectedGroupSoal == "") {
        this.$notification["error"]({
          message: this.$t("general.message.error.title"),
          description: this.$t("ujian.start-examp.error-kategori-soal"),
          class: "ant-alert-error",
        });
      } else {
        this.iconLoading = true;
        this.isChangeSoal = true;
        this.$store.commit("setSelectedKategori", this.selectedGroupSoal);
        this.$store.commit("setIndexSoal", 0);
        this.setVariable();
      }
    },
    changeGroupFalse() {
      this.isChangeSoal = false;
      this.visible = false;
    },
    nextSoal() {
      if (this.itemSoal.list.list_questions.length - 1 == this.itemSoal.index)
        this.itemSoal.index = 0;
      else this.itemSoal.index++;
      this.getSoal();
    },
    prevSoal() {
      if (0 == this.itemSoal.index)
        this.itemSoal.index = this.itemSoal.list.list_questions.length - 1;
      else this.itemSoal.index--;
      this.getSoal();
    },
    endSoal() {
      if (
        this.itemKategoriSoal.list[
          this.itemKategoriSoal.list.findIndex(
            (item) =>
              item.id_group ==
              this.$store.state.participant.ujian.selected_kategori
          )
        ].number_of_remain == "00" &&
        this.isChangeSoal
      ) {
        this.sub_title = this.$t("ujian.ujian-dashboard.finish-one-group", {
          groupname: this.itemSoal.list.nama,
        });
        this.isChangeSoal = true;
        this.icontype = "info";
        this.visible = true;
      }
    },
    finishExamp(value) {
      this.spinning = value;
      this.spinstyle = "spin-show";
      setTimeout(() => {
        this.isTimeFinish = true
        this.spinning = false;
        this.$router.push("finish");
      }, 2000);
    },
    inFinishExamp(value) {
      this.visibleFinish = value;      
    },
    inFinishOK(){
      this.visibleFinish = false; 
      this.spinning = true;
      this.spinstyle = "spin-show";
      setTimeout(() => {
        this.isTimeFinish = true
        this.spinning = false;
        this.$router.push("finish");
      }, 2000);
    },
    inFinishCancel(){
      this.visibleFinish = false; 
    },
    getDateTimeUjian() {
      this.isLoadSoal = true;
      get("UJIAN", "Participant/GetStartDateTimeUjian", {
        id_participant: this.$store.state.participant.biodata.id,
        id_period: this.$store.state.participant.ujian.id_period,
      }).then((response) => {
        let res = response.data;

        this.$store.commit("setStartUjian", {
          start_ujian: true,
          date_ujian: res.date_start_examp,
        });
        this.tglStart =
          Date.now() +
          res.amount_of_time * 60000 -
          (new Date(res.date_server).valueOf() -
            new Date(res.date_start_exampt).valueOf());
            // console.log(this.tglStart, res.date_server, res.date_start_exampt, Date.now());
        if (this.tglStart < Date.now()) {
          this.isTimeFinish = true;   
          this.$router.push("finish");
        }
        if (!res.is_start_exampt) 
        {
          this.setDateTimeUjian();          
        }
        this.setVariable();
        
      });
    },
    setDateTimeUjian() {
      post("UJIAN", "Participant/SetStartDateTimeUjian", {
        id_participant: this.$store.state.participant.biodata.id,
        id_period: this.$store.state.participant.ujian.id_period,
      }).then((response) => {
        let res = response.data;
        console.log(res);
      });
    },
    setVariable() {
        this.itemKategoriSoal.list = this.$store.state.participant.ujian.list_soal;
        this.itemKategoriSoal.list.forEach((element, index) => {
          this.itemKategoriSoal.list[index].number_of_answer = (
            "00" +
            this.itemKategoriSoal.list[index].list_questions.filter(
              (m) => m.list_answer[0].status == 1
            ).length
          ).slice(-2);
          this.itemKategoriSoal.list[index].number_of_remain = (
            "00" +
            (this.itemKategoriSoal.list[index].number_of_questions -
              this.itemKategoriSoal.list[index].number_of_answer)
          ).slice(-2);
          this.$store.commit("setJumlahSoal", {
            indexGroup: index,
            number_of_answer: this.itemKategoriSoal.list[index].number_of_answer,
            number_of_remain: this.itemKategoriSoal.list[index].number_of_remain,
          });
        });

        

        this.itemKategoriSoal.selected = this.$store.state.participant.ujian.selected_kategori;
        this.itemSoal.index = this.$store.state.participant.ujian.index_soal;
        this.itemSoal.list = this.itemKategoriSoal.list[
          this.itemKategoriSoal.list.findIndex(
            (item) => item.id_group === this.itemKategoriSoal.selected
          )
        ];
        if (
          this.itemKategoriSoal.list[
            this.itemKategoriSoal.list.findIndex(
              (item) =>
                item.id_group ==
                this.$store.state.participant.ujian.selected_kategori
            )
          ].number_of_remain == 0
        )
          this.isChangeSoal = false;
        this.getSoal();
      
    },
    setSoal(value) {
      this.itemSoal.index = value;
      this.getSoal();
    },
    setFlag(value) {
      var id_bank_question = this.itemSoal.list.list_questions[value].id_bank_question;
      var index = this.itemSoal.list.list_questions.findIndex(
        (item) => item.id_bank_question == id_bank_question
      );
      var indexGroup = this.itemKategoriSoal.list.findIndex(
        (item) =>
          item.id_group == this.$store.state.participant.ujian.selected_kategori
      );
      var listJawab = Object.assign(
        {},
        this.itemSoal.list.list_questions[index].list_answer[0]
      );
      if (listJawab.flag == 0) listJawab.flag = 1;
      else listJawab.flag = 0;
      this.itemSoal.list.list_questions[index].list_answer[0].flag =
        listJawab.flag;
      this.itemDetailSoal.list_answer_participant.flag = listJawab.flag;
      post("UJIAN", "Participant/SimpanJawaban", {
        id_participant: this.$store.state.participant.biodata.id,
        id_bank_question: id_bank_question,
        answer: this.itemDetailSoal.list_answer_participant.answer,
        status: listJawab.status,
        flag: listJawab.flag,
      }).then((response) => {
        if (status == 1) {
          this.$store.commit("setFlag", {
            indexGroup: indexGroup,
            index: index,
            flag: listJawab.flag,
          });
          this.$notification["success"]({
            message: this.$t("ujian.success-message.title"),
            description: response.data,
            class: "ant-alert-success",
          });
        }
      });
    },
    setJawaban(selected, id_bank_question, status) {
      this.isLoadSoal = true;
      var index = this.itemSoal.list.list_questions.findIndex(
        (item) => item.id_bank_question == id_bank_question
      );
      var indexGroup = this.itemKategoriSoal.list.findIndex(
        (item) =>
          item.id_group == this.$store.state.participant.ujian.selected_kategori
      );
      var listJawab = Object.assign(
        {},
        this.itemSoal.list.list_questions[index].list_answer[0]
      );
      listJawab.status = status;
      this.itemSoal.list.list_questions[index].list_answer[0].status =
        listJawab.status;
      this.itemDetailSoal.list_answer_participant.status = listJawab.status;
      this.itemDetailSoal.list_answer_participant.flag = listJawab.flag;

      post("UJIAN", "Participant/SimpanJawaban", {
        id_participant: this.$store.state.participant.biodata.id,
        id_bank_question: id_bank_question,
        answer: selected,
        status: listJawab.status,
        flag: listJawab.flag,
      }).then((response) => {
        if (response.status == 200) {
          this.isLoadSoal = false;
          this.itemSoal.list.list_questions[index].list_answer[0].status =
            listJawab.status;
          this.itemDetailSoal.list_answer_participant.status = listJawab.status;
          this.itemDetailSoal.list_answer_participant.flag = listJawab.flag;
          this.itemDetailSoal.list_answer_participant.answer = selected;

          this.itemKategoriSoal.list[indexGroup].number_of_answer = (
            "00" +
            this.itemSoal.list.list_questions.filter(
              (m) => m.list_answer[0].status == 1
            ).length
          ).slice(-2);
          this.itemKategoriSoal.list[indexGroup].number_of_remain = (
            "00" +
            (this.itemKategoriSoal.list[indexGroup].number_of_questions -
              this.itemKategoriSoal.list[indexGroup].number_of_answer)
          ).slice(-2);

          this.itemjawaban = this.itemDetailSoal.list_answer[
            this.itemDetailSoal.list_answer.findIndex(
              (n) => n.id_answer == this.itemDetailSoal.list_answer_participant.answer
            )
          ];
          this.$store.commit("setJumlahSoal", {
            indexGroup: indexGroup,
            number_of_answer: this.itemKategoriSoal.list[indexGroup].number_of_answer,
            number_of_remain: this.itemKategoriSoal.list[indexGroup].number_of_remain,
          });
          this.$store.commit("setStatus", {
            indexGroup: indexGroup,
            index: index,
            status: status,
          });

          // if(status == 1)
          // {
          // this.$notification["success"]({
          //   message: this.$t("ujian.success-message.title"),
          //   description: response.data,
          //   class: "ant-alert-success",
          // });
          // }
        }
      });
    },

    getSoal() {
      if (!this.isTimeFinish) {
        this.isLoadSoal = true;
        get("UJIAN", "Participant/SoalID", {
          id_bank_question: this.itemSoal.list.list_questions[this.itemSoal.index]
            .id_bank_question,
          id_participant: this.$store.state.participant.biodata.id,
        }).then((response) => {
          let res = response.data;
          this.itemDetailSoal = res;

          var index = this.itemSoal.list.list_questions.findIndex(
            (item) =>
              item.id_bank_question ==
              this.itemSoal.list.list_questions[this.itemSoal.index]
                .id_bank_question
          );
          var indexGroup = this.itemKategoriSoal.list.findIndex(
            (item) =>
              item.id_group ==
              this.$store.state.participant.ujian.selected_kategori
          );
          
          this.$store.commit("setStatus", {
            indexGroup: indexGroup,
            index: index,
            status: this.itemDetailSoal.list_answer_participant.status,
          });
          this.$store.commit("setFlag", {
            indexGroup: indexGroup,
            index: index,
            flag: this.itemDetailSoal.list_answer_participant.flag,
          });
          this.$store.commit("setIndexSoal", this.itemSoal.index);
          this.itemjawaban = this.itemDetailSoal.list_answer[
            this.itemDetailSoal.list_answer.findIndex(
              (n) => n.id_answer == this.itemDetailSoal.list_answer_participant.answer
            )
          ];
          // if(this.itemKategoriSoal.list[this.itemKategoriSoal.list.findIndex(
          //     (item) =>
          //       item.id_group == this.$store.state.participant.ujian.selected_kategori
          //   )].number_of_remain > 0)
          // this.isChangeSoal = true;
          this.iconLoading = false;
          this.visible = false;
          this.isLoadSoal = false;
          this.endSoal();
          this.isLoadSoal = false;
        });
      }
    },
  },

  created() {    
    this.getDateTimeUjian();
  },
};
</script>

<style scoped>
.gutter-example >>> .ant-row > div {
  background: transparent;
  border: 0;
}

.spin-content {
  border: 1px solid #91d5ff;
  background-color: #363636;
  padding: 30px;
}

/* .gutter-box-ujian {
  background: #fff;
  padding: 5px 0;
  min-height: '380px'
} */

.spin-show {
  border: 1px solid #91d5ff;
  background-color: #e6f7ff;
}

.mark-button {
  line-height: 1.499;
  position: relative;
  display: inline-block;
  font-weight: 400;
  white-space: nowrap;
  text-align: center;
  background-image: none;
  border: 1px solid transparent;
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.015);
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  touch-action: manipulation;
  height: 32px;
  padding: 0 15px;
  font-size: 14px;
  border-radius: 4px;
  color: rgba(0, 0, 0, 0.65);
  background-color: #fff;
  border-color: rgb(255, 208, 0);
}

.marker {
  background-color: rgb(255, 208, 0) !important;
}

.example {
  text-align: center;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  margin-bottom: 20px;
  padding: 30px 50px;
  /* margin: 20px 0; */
}

.ant-result-content {
  padding: 0px !important;
}
</style>
